<template>
  <div
    class="order-desc-group c:col-center-stretch"
    :style="{
      '--padding-y': computedPaddingY,
      '--item-gap': computedItemGap,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    isPanel: {
      type: Boolean,
      default: false,
    },
    paddingY: {
      type: [String, Number],
      default: "0",
    },
    itemGap: {
      type: [String, Number],
      default: "0",
    },
  },
  computed: {
    computedPaddingY() {
      switch (typeof this.paddingY) {
        case "string":
          if (+this.paddingY == this.paddingY)
            return `${this.paddingY / 20}rem`;
          return this.paddingY;

        case "number":
          return `${this.paddingY / 20}rem`;

        default:
          return `0`;
      }
    },
    computedItemGap() {
      switch (typeof this.itemGap) {
        case "string":
          if (+this.itemGap == this.itemGap) return `${this.itemGap / 20}rem`;
          return this.itemGap;

        case "number":
          return `${this.itemGap / 20}rem`;

        default:
          return `0`;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.order-desc-group {
  --padding-y: 0;
  --item-gap: 0;

  gap: var(--item-gap);

  width: 100%;
  padding: var(--padding-y) 0;
  border-top: 1/20rem solid #e4e4e4;

  &:first-child,
  &:first-of-type {
    border-top: none;
  }
}
</style>
